import { useDispatch, useSelector } from 'react-redux';
import { deleteReservation } from 'redux/actions/reservation';
import { getCurrentBooking } from 'redux/selectors/current_booking';
import BookingCartItem from './booking_cart_item';

export function BookingCartItems() {
  const booking = useSelector(getCurrentBooking);
  const { reservations_attributes: reservations } = booking;
  const passengerTypes = useSelector((state) => state.types.passengerTypes);

  const dispatch = useDispatch();

  function edit(reservationID) {
    // eslint-disable-next-line no-console
    console.log(`Edit ${reservationID}`);
  }

  function remove(bookingID, reservationID) {
    return dispatch(deleteReservation(bookingID, reservationID));
  }

  return (
    <div className="booking-cart-items space-y-4">
      {reservations &&
        reservations.map((reservation) => (
          <BookingCartItem
            key={reservation.id}
            reservation={reservation}
            passengerTypes={passengerTypes}
            booking={booking}
            // eslint-disable-next-line react/jsx-no-bind
            onEdit={edit}
            // eslint-disable-next-line react/jsx-no-bind
            onRemove={remove}
          />
        ))}
    </div>
  );
}
